module.exports = __webpack_public_path__ + "img/desktop-neck-5_60x75.198bb0e3.png";